import { render, staticRenderFns } from "./TextRows.vue?vue&type=template&id=27645d7c"
import script from "./TextRows.vue?vue&type=script&lang=js"
export * from "./TextRows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports